import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';

const HomeTitles:FC = () => {
  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  if (!quiz) return null;

  const { title1, title2, title3 } = quiz.landingPage;

  return (
    <div className="py-4 text-primary text-center font-bold">
      {title1 ? <p className="text-2xl mb-1">{title1}</p> : null}
      {title2 ? <p className="text-4xl font-extrabold mb-1">{title2}</p> : null}
      {title3 ? <p className="text-lg">{title3}</p> : null}
    </div>
  )
}

export default HomeTitles;
